"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import type { ApiDropVoteEditLog } from "@/generated/models/ApiDropVoteEditLog";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
const DROP_VOTE_LOGS_LIMIT = 20;
const DROP_VOTE_LOGS_SORT_DIRECTION = "DESC";
interface UseDropVoteLogsProps {
  readonly dropId: string;
  readonly enabled?: boolean | undefined;
}
const getNormalizedDropId = (dropId: string): string => dropId.trim();
const getDropVoteLogsEndpoint = (dropId: string): string => `v2/drops/${encodeURIComponent(dropId)}/votes/logs`;
export function useDropVoteLogs(t0) {
  const $ = _c(22);
  const {
    dropId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== dropId) {
    t2 = getNormalizedDropId(dropId);
    $[0] = dropId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedDropId = t2;
  const canFetch = enabled && normalizedDropId.length > 0;
  let t3;
  if ($[2] !== normalizedDropId) {
    t3 = [QueryKey.DROP_VOTE_LOGS, {
      dropId: normalizedDropId,
      limit: DROP_VOTE_LOGS_LIMIT,
      sortDirection: DROP_VOTE_LOGS_SORT_DIRECTION
    }];
    $[2] = normalizedDropId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const queryKey = t3;
  let t4;
  if ($[4] !== normalizedDropId) {
    t4 = async t5 => {
      const {
        pageParam
      } = t5;
      return await commonApiFetch({
        endpoint: getDropVoteLogsEndpoint(normalizedDropId),
        params: {
          limit: DROP_VOTE_LOGS_LIMIT.toString(),
          offset: pageParam.toString(),
          sort_direction: DROP_VOTE_LOGS_SORT_DIRECTION
        }
      });
    };
    $[4] = normalizedDropId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getDefaultQueryRetry();
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== canFetch || $[8] !== queryKey || $[9] !== t4) {
    t6 = {
      queryKey,
      queryFn: t4,
      initialPageParam: 0,
      getNextPageParam: _temp,
      placeholderData: keepPreviousData,
      enabled: canFetch,
      staleTime: 60000,
      ...t5
    };
    $[7] = canFetch;
    $[8] = queryKey;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const query = useInfiniteQuery(t6);
  let t7;
  if ($[11] !== query.data?.pages) {
    t7 = query.data?.pages.flat() ?? [];
    $[11] = query.data?.pages;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const logs = t7;
  let t8;
  if ($[13] !== logs || $[14] !== query.error || $[15] !== query.fetchNextPage || $[16] !== query.hasNextPage || $[17] !== query.isError || $[18] !== query.isFetchingNextPage || $[19] !== query.isLoading || $[20] !== query.refetch) {
    t8 = {
      logs,
      fetchNextPage: query.fetchNextPage,
      hasNextPage: query.hasNextPage,
      isLoading: query.isLoading,
      isFetchingNextPage: query.isFetchingNextPage,
      isError: query.isError,
      error: query.error,
      refetch: query.refetch
    };
    $[13] = logs;
    $[14] = query.error;
    $[15] = query.fetchNextPage;
    $[16] = query.hasNextPage;
    $[17] = query.isError;
    $[18] = query.isFetchingNextPage;
    $[19] = query.isLoading;
    $[20] = query.refetch;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp(lastPage, allPages) {
  return lastPage.length === DROP_VOTE_LOGS_LIMIT ? allPages.length * DROP_VOTE_LOGS_LIMIT : null;
}